import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './Indicateurs.css';
import CountUp from 'react-countup';

const Indicateurs = ({ title, value, icon, iconcolor, trend, isSticky }) => {
  // Formatter la valeur pour l'affichage
  const numericValue = typeof value === 'number' ? value : parseFloat(value);
  const isPercentage = typeof value === 'string' && value.includes('%');
  const formattedValue = isPercentage ? numericValue + '%' : 
    isNaN(numericValue) ? value : numericValue.toLocaleString();

  // Couleur par défaut
  const color = iconcolor || 'var(--primary-green)';

  return (
    <div className={`gov-card mb-0 ${isSticky ? 'sticky-card' : ''}`}>
      <div className="gov-card-body">
        <h5 className="gov-card-title">{title}</h5>
        <div className="gov-card-content">
          <div className="gov-card-icon" style={{ backgroundColor: color }}>
            <i className={`fas ${icon}`} style={{ color: 'white', fontSize: '24px' }}></i>
          </div>
          <div className="gov-card-text">
            <h3 className="gov-value">
              <CountUp end={numericValue || 0} duration={2} separator="," decimals={isPercentage ? 1 : 0} suffix={isPercentage ? '%' : ''} />
              {trend && (
                <span className={`trend-badge ${trend === 'up' ? 'trend-up' : 'trend-down'}`}>
                  <i className={`fas ${trend === 'up' ? 'fa-arrow-up' : 'fa-arrow-down'}`}></i>
                </span>
              )}
            </h3>
            <span className="gov-subtitle">
              {title.includes('Nationale') ? 'Valeur nationale' : 'Référence mondiale'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Indicateurs;
